
import React, {FC, useState} from 'react';
import {Section as Query} from 'templates/reports/query';
import Selector from 'templates/reports/Section/Snapshot/Selector';

import {Charts} from './Charts';

import * as styles from './styles.module.scss';

type SnapshotProps = {
	data: Query
}

export const Snapshot: FC<SnapshotProps> = ({data}) => {
	const [index, setIndex] = useState(0);
	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<h2>Regional breakdown by scan</h2>
				<Selector
					results={data.results}
					onSelect={setIndex}
				/>
			</div>
			<p>
				See how individual regions compare to your total
				body measurements in a single scan.
			</p>
			<Charts data={data.results[index]} />
		</div>
	);
};
